import React from 'react';

const initialValues = {
  isImportFinished: false,
  importErrorObject: null,
  importResponse: {},
  importTestCases: () => undefined,
  errorMessages: [],
  resetContext: () => undefined,
};

export const ImportTestCasesStatusContext = React.createContext(initialValues);
